/**
 * Presigned MinIO/S3 URLs differ by query string; cache by stable path only.
 * @param {string} url
 */
export function stableMediaCacheKey(url) {
  try {
    const u = new URL(url);
    return `${u.origin}${u.pathname}`;
  } catch {
    return url.split('?')[0] ?? url;
  }
}

/** @param {string} url */
export function mediaCacheRequest(url) {
  const key = stableMediaCacheKey(url);
  return new Request(key);
}

/** @param {string} url */
export function isMediaAssetUrl(url) {
  if (!url) return false;
  try {
    const u = new URL(url);
    if (u.pathname.match(/\.(jpg|jpeg|png|webp|mp4|webm|mov)$/i)) return true;
    if (u.pathname.startsWith('/api/media/')) return true;
    if (u.hostname.endsWith('.r2.cloudflarestorage.com')) return true;
    return false;
  } catch {
    return false;
  }
}
